import { menuSectionTypes } from '../../models';

export const getters = {
  currentMenu: (state) => state.currentMenu,
  isMenuManaged: (state) => state.currentMenu && state.currentMenu.is_managed,
  currentSection: (state) => state.currentSection,
  currentSectionList: (state) => state.currentSectionList,
  currentSectionProducts: (state) => (state.currentSection ? state.currentSection.products : []),
  isClause: (state, globalGetters) => state.currentSection && state.currentSection.type === globalGetters.clauseId,
  isSection: (state, globalGetters) => state.currentSection && state.currentSection.type === globalGetters.sectionId,
  isSubsection: (state, globalGetters) => state.currentSection && state.currentSection.type === globalGetters.subsectionId,
  currentSectionCodeName: (state, globalGetters) => {
    const sectionType = state.currentSection ? globalGetters.menuSectionTypesList.find((el) => el.id === state.currentSection.type) : null;
    return sectionType ? sectionType.code_name : menuSectionTypes.MENU;
  },
  currentTemplate: (state, globalGetters) => (state.currentMenu ? globalGetters.templateList.find((el) => el.guid === state.currentMenu.template) : null),
  parentClause: (state) => state.parentClause,
  parentSection: (state) => state.parentSection,
  sectionCache: (state) => state.sectionCache,
  getSectionByGuid: (state) => (guid) => state.sectionCache.find((sec) => sec.guid === guid),
};
